import styled from 'styled-components';

export const Checkbox = styled.input.attrs({
  className: 'Checkbox',
  type: 'checkbox',
})`
  margin: 0 2px;
  cursor: pointer;
  accent-color: maroon;
`;

interface KeypointOptionContainerProps {
  isLabeled: boolean;
  isActive: boolean;
}

export const KeypointOptionContainer = styled.div.attrs({
  className: 'KeypointOptionContainer',
})<KeypointOptionContainerProps>(
  ({ isLabeled, isActive }) => `
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0.75em 1em;
    cursor: pointer;
    font-size: 12px;
    background: ${isActive ? '#2a98e8' : isLabeled ? 'lightpink' : 'none'};
    &:hover {
      background: ${isActive ? '#2a98e8' : isLabeled ? 'pink' : 'none'};
    }
  `
);
